<template>
  <div class="sticky-list">
    <div class="sticky-list__not-sticky">
      <WidgetList :widgets="notStickyWidgets" />
    </div>
    <div class="sticky-list__sticky">
      <WidgetList :widgets="stickyWidgets" />
    </div>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import type { TContent } from '~/types/common';
  import WidgetList from '~/components/Widgets/WidgetList.vue';

  export default defineNuxtComponent({
    name: 'StickyList',

    components: {
      WidgetList,
    },

    props: {
      widgets: {
        type: Array as PropType<TContent[]>,
        default: () => [],
      },

      // указывает сколько виджетов сделать sticky
      // сначала или с конца исходного массива
      // sliceSticky: {
      //   type: Number as PropType<number>,
      //   default: () => -1
      // },

      // типы виджетов, которые должны прилипать
      stickyContentType: {
        type: Array as PropType<string[]>,
        default: () => ['bh-kiss__posts-collection'],
      },
    },

    computed: {
      stickyWidgets() {
        return [
          ...this.widgets.filter((widget) => this.stickyContentType.includes(widget.type)),
          // пристыковываем последний рекламный блок
          ...(this.widgets.slice(-1)[0]?.type === 'bh-kiss__html' ? this.widgets.slice(-1) : []),
        ];
      },

      notStickyWidgets() {
        const widgetsWithoutLastAdBanner =
          this.widgets.slice(-1)[0]?.type === 'bh-kiss__html'
            ? this.widgets.slice(0, -1)
            : this.widgets;

        return widgetsWithoutLastAdBanner.filter(
          (widget) => !this.stickyContentType.includes(widget.type),
        );
      },
    },
  });
</script>

<style lang="scss" scoped>
  .sticky-list {
    position: relative;

    &__not-sticky {
      margin-bottom: 24px;
    }

    &__sticky {
      position: sticky;
      // высота шапки (48px) + отступ
      top: calc(48px + 24px);
    }
  }
</style>
